module.exports = __webpack_public_path__ + "img/logo.60d618f2.png";